import React, { useState, useEffect } from 'react'
import { Table, Form, Alert, Button,Modal } from 'react-bootstrap'
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import Backdrop from '../backdrop/backdrop'

function RevisedOrderAmountModalPopup({revisedOrderAmtToBeUpdated,driver_id,order_id,...props}) {
  const [loading,setLoading] = useState(false);
  const [revisedAmt,setRevisedAmt] = useState(revisedOrderAmtToBeUpdated);

  const updateRevisedAmtValue = () => {
    let revisedOrderAmt=revisedAmt?Number(revisedAmt):0;
    revisedOrderAmt=revisedOrderAmt.toFixed(2);
    props.callback(driver_id,order_id,revisedOrderAmt);
    props.onHide();
  }

    return (<>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Total Amount
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Table>
                    <tbody>
                        <tr>
                            <td>Revised Order Amount</td>
                            <td><Form.Control type="text" defaultValue={revisedAmt} onChange={(e)=>{ setRevisedAmt(e.target.value); }}/></td>
                        </tr>
                    </tbody>
                </Table>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{updateRevisedAmtValue(); }}>OK</Button>
                    <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
            {loading ? (<Backdrop parentLoadStatus={loading} />) : (null)}
        </>
    )
}

export default RevisedOrderAmountModalPopup
